import { Box, Button, Stack, Text, VStack } from "@chakra-ui/react";
import { lazy, Suspense, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TitlePageDashboard } from "../../../components/button/TitlePageDashboard";
import { ProductSupplierInfo } from "../../../components/dashboard_reseller/ProductSupplierInfo";
import LazyLoadOnScroll from "../../../components/LazyLoadOnScroll";
import { CardSkeleton } from "../../../components/skeleton/CardSkeleton";
import { DetailProductSupplierData } from "../../../constants/Supplier";
import useCustomToast from "../../../lib/useCustomToast";
import useScreenWidth from "../../../lib/useScreenWidth";
import { useDarkWhiteColor } from "../../../themes/colors";
import { axiosReseller } from "../../../utils/AxiosInstance";
import { ProductAdded } from "../../../components/card/ProductAdded";
import { useTriggerRenderStore } from "../../../store/useTriggerRenderStore";
import { useAddProduct } from "../../../hooks/fetchApi";

const ImageSliderProduct = lazy(
  () => import("../../../components/ImageSliderProduct")
);

const MoreProductSupplier = lazy(
  () => import("../../../components/dashboard_reseller/MoreProductSupplier")
);

export const DetailProductSupplier = () => {
  const { id } = useParams();
  const [data, setData] = useState<DetailProductSupplierData | undefined>(
    undefined
  );
  const [loaded, setLoaded] = useState<boolean>(false);
  const bgBnw = useDarkWhiteColor();
  const sw = useScreenWidth();
  const toast = useCustomToast();
  const { statusData, setStatusData } = useTriggerRenderStore();
  const { isFetchLoading, addProduct } = useAddProduct();

  const addProductToStore = () => {
    addProduct(data?.product.id);
    setStatusData();
  };

  useEffect(() => {
    axiosReseller
      .get(`/v1/reseller/product/detail/${id}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [id, statusData]);

  return (
    <VStack
      className="detail-product-page"
      w={"100%"}
      h={"100dvh"}
      gap={0}
      bg={bgBnw}
      align={"stretch"}
      position={"relative"}
      overflowY={"auto"}
    >
      <VStack w={"100%"} p={4} align={"stretch"}>
        <TitlePageDashboard title="Detail Produk" isSubPage={true} />

        <Stack
          className="root-product-info"
          direction={["column", "column", "column", "row", "row"]}
          gap={4}
        >
          <Suspense fallback={<CardSkeleton row={1} height={350} />}>
            <ImageSliderProduct
              data={data?.product.images as string[]}
              maxW={["300px", null, "600px", "400px"]}
              alignSelf={["center", null, null, "start", "start"]}
            />
          </Suspense>

          <ProductSupplierInfo
            data={data}
            loaded={loaded}
            onRefresh={() => setStatusData()}
          />
        </Stack>

        {data && data.more_products && data.more_products.length > 0 && (
          <>
            <Text textStyle={"h-reg-title"} mt={4}>
              Produk lainnya dari toko ini
            </Text>

            <LazyLoadOnScroll>
              <Suspense fallback={<CardSkeleton row={9} height={435} />}>
                <MoreProductSupplier
                  data={data.more_products}
                  mb={sw < 640 ? 20 : 12}
                />
              </Suspense>
            </LazyLoadOnScroll>
          </>
        )}
      </VStack>

      {sw < 640 && (
        <Box
          w={"100%"}
          px={4}
          py={2}
          bg={bgBnw}
          boxShadow={"0px 0px 10px rgba(0, 0, 0, 0.25)"}
          position={"fixed"}
          bottom={0}
          zIndex={10}
        >
          {data?.product.added === 0 ? (
            <Button
              w={"100%"}
              size={"md"}
              borderRadius={"md"}
              variant={"outline"}
              colorScheme="red"
              isDisabled={loaded && !isFetchLoading ? false : true}
              onClick={addProductToStore}
            >
              Tambahkan produk ke store
            </Button>
          ) : (
            <ProductAdded p={1.5} />
          )}
        </Box>
      )}
    </VStack>
  );
};
